const selectImages = (data) => {
  return new Promise((res) => {
    window.HiyaJSBridge.callHandler("selectImages", data, ({ imageIds }) => {
      res(imageIds);
    });
  });
};
selectImages.Multi = (data = {}) => selectImages({ maxNum: 9, ...data, singleSelected: false });
selectImages.Single = (data = {}) => selectImages({ singleJumpEdit: true, singleJumpEditW2H: 1, ...data, singleSelected: true });
export {
  selectImages
};
